import { all, call, put, type SagaReturnType, takeLatest } from 'redux-saga/effects';

import { handleErrorAction } from 'store/errors/actions';

import { navigateBack, navigateTo } from './actions';
import { NAVIGATE, NAVIGATE_BACK } from './actionTypes';

/**
 * Loaded lazily (not via a top-level import) on purpose: the router statically
 * imports the route table and layouts, which in turn reach back into the store.
 * A static import here would pull that whole graph into store initialization and
 * break module init ordering (TDZ). At runtime the router singleton already exists.
 */
const getRouter = () => import('router').then((module) => module.default);

function* navigateSaga({ payload }: ReturnType<typeof navigateTo>): Generator<unknown, void, unknown> {
    try {
        const { url, options } = payload;
        const router = (yield call(getRouter)) as SagaReturnType<typeof getRouter>;

        yield router.navigate(url, options);
    } catch (error) {
        yield put(handleErrorAction(error, payload));
    }
}

function* navigateBackSaga({ payload }: ReturnType<typeof navigateBack>): Generator<unknown, void, unknown> {
    try {
        const router = (yield call(getRouter)) as SagaReturnType<typeof getRouter>;

        yield router.navigate(payload?.amount || -1);
    } catch (error) {
        yield put(handleErrorAction(error, payload));
    }
}

export default function* watchNavigation(): Generator<unknown, void, unknown> {
    yield all([takeLatest(NAVIGATE, navigateSaga)]);
    yield all([takeLatest(NAVIGATE_BACK, navigateBackSaga)]);
}
